import { createAifcDebugSelectionsEffect } from '@databases/devtools/selections-effect';
import { getService } from '@databases/service-container';

import { SelectionFeatureKeys, type SelectionEffectFeature } from '../../features/types';

export function createAifcDebugSelectionsEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.AIFC_DEBUG_SELECTIONS_EFFECT,
    type: 'effect',
    factory: () =>
      createAifcDebugSelectionsEffect({
        selectionsApi: getService('SelectionsApi'),
      }),
  };
}
